import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { customEmailSenderSchema } from "./custom-email-sender";

/**
 * Re-check the SES identity and DNS records of a sender's domain now, instead
 * of waiting for the scheduled refresh, and return the updated sender.
 */
export const refreshCustomEmailSenderDomainStatus = {
  name: "refreshCustomEmailSenderDomainStatus" as const,
  input: z.object({
    teamId: zExt.objectId(),
    integrationId: z.string().min(1),
  }),
  output: z.object({ sender: customEmailSenderSchema }),
};
